import is from '@sindresorhus/is';
import Maybe from 'true-myth/maybe';

export type User = {
    readonly firstName?: string;
    readonly lastName?: string;
};

export const getUserName = (user: Maybe<User>, masked = false): string => {
    return user.mapOr('', (userValue) => {
        const firstName = Maybe.of(userValue.firstName).unwrapOr('');
        const lastName = Maybe.of(userValue.lastName).unwrapOr('');
        const userName = `${firstName} ${lastName}`.trim();

        if (masked && is.nonEmptyString(userName)) {
            return '*******';
        }

        return userName;
    });
};
